module.exports = __webpack_public_path__ + "img/Group-bg-sec1.6790901a.png";